module.exports = __webpack_public_path__ + "img/bus_model.b8e5bb17.png";